import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import s from './QualityGoalsReport.module.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import Banner from '../Banner/Banner';
import QualityGoalsReportListTable from './QualityGoalsReportListTable';
import Pagination from '../Pagination/Pagination';
import { DEFAULT_PAGE_SIZE } from '../../constants';
import Dropdown from '../WSAControls/DroprdownContainer/Dropdown';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { compareValues } from '../../utils';
import { getUserProfileWidget, getQualityGoals, getGeneralData, getCurrentTimezone } from '../../selectors/index';
import { WidgetVisibility, IsWidgetAccessible } from '../../utils/widgetManager';
import { initialQualityGoalsState } from '../../store/reducers/initialState';
import Button from 'react-bootstrap/Button';
import { useHistory, useParams } from 'react-router-dom';
import SiteDashboardControlsContentTemplate from '../SiteDashboardControls/SiteDashboardControlsContentTemplate';
import Breadcrumb from '../WSAControls/Breadcrumb';
import ConfirmDialog from '../ConfirmDialog/ConfirmDialog';
import Cookies from 'js-cookie';

import {
  getQualityGoalsThunk,
  setQualityGoalsChangeThunk,
  getFilterThunk,
  setFilteredDataThunk,
  setCurrentPage,
  setPageFilter,
  saveQualityGoalsThunk
} from '../../store/actions/qualityGoals';

const SITE = 'SITE';
const ENTITY_TYPE = 'ENTITY_TYPE';
const ENTITY = 'ENTITY';
const TEST_PURPOSE = 'TEST_PURPOSE';
const envName = process.env.REACT_APP_ENV_NAME_SHORT;

const QualityGoalsReportList = ({ intl }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const userProfileWidgets = useSelector(state => getUserProfileWidget(state));
  const qualityGoals = useSelector(state => getQualityGoals(state));
  const generalData = useSelector(state => getGeneralData(state));
  const { siteId, segmentName, selectedTab, entityId } = useParams();

  // //clean up
  useEffect(() => {
    return () => {
      dispatch(
        setQualityGoalsChangeThunk({
          ...initialQualityGoalsState.qualityGoals
        })
      );
    };
  }, []);

  const [active, setActive] = useState(false);
  const [qualityGoalReportId, setQualityGoalReportId] = useState(0);
  const [filterSiteId, setFilterSiteId] = useState(0);
  const [filterEntityTypeId, setFilterEntityTypeId] = useState(0);
  const [filterEntityId, setFilterEntityId] = useState(0);
  const [filterTestPurposeId, setFilterTestPurposeId] = useState(0);

  const [entitySubTypes, setEntitySubTypes] = useState([]);
  const [asendingOrder, setAsendingOrder] = useState(true);
  const currentTimezone = useSelector(state => getCurrentTimezone(state));

  let offset = qualityGoals.offset || 0;
  let limit = qualityGoals.limit || 1000;

  let filterLocalSiteId = siteId || qualityGoals.filterBy.filterSiteId || null;
  let filterLocalEntityId = entityId || qualityGoals.filterBy.filterEntityId || null;
  let filterLocalEntityTypeId = qualityGoals.filterBy.filterEntityTypeId || null;
  let filterLocalTestPurposeId = qualityGoals.filterBy.filterTestPurposeId || null;

  let isOpSuccessful = qualityGoals.isOpSuccessful || false;

  useEffect(() => {
    dispatch(getFilterThunk('WQSP_QUALITYGOALSREPORT_LIST', siteId));
  }, [dispatch, getFilterThunk, siteId]);

  useEffect(() => {
    let filterObj = {
      filterSiteId: filterLocalSiteId,
      filterEntityId: filterLocalEntityId,
      filterEntityTypeId: filterLocalEntityTypeId,
      filterTestPurposeId: filterLocalTestPurposeId,
      offset: offset,
      limit: limit
    };
    dispatch(getQualityGoalsThunk(filterObj, 'WQSP_QUALITYGOALSREPORT_LIST'));
  }, [getQualityGoalsThunk]);

  let disableControls = (qualityGoals && qualityGoals.isLoading) || false;

  let messageId = (qualityGoals && qualityGoals.displayMessageCode) || 'none';
  const messageText = intl.formatMessage({ id: messageId, defaultMessage: messageId });

  const siteOptions = () => {
    let siteData = [];

    generalData.sites.forEach(element => {
      siteData.push({
        label: element.Name,
        value: element.SiteId
      });
    });

    let sortedData = siteData.sort(compareValues('label'));
    sortedData.splice(0, 0, {
      label: <FormattedMessage id="wqsp.filters.allSites" defaultMessage="All Sites" />,
      value: 0
    });
    return sortedData;
  };

  const entityTypeOptions = () => {
    let entityTypeData = [];

    generalData.entityTypes.forEach(element => {
      entityTypeData.push({
        ...element,
        label: element.Name,
        value: element.EntityTypeId
      });
    });

    let sortedData = entityTypeData.sort(compareValues('label'));
    sortedData.splice(0, 0, {
      label: <FormattedMessage id="wqsp.filters.allEntityTypes" defaultMessage="All Entity Types" />,
      value: 0
    });
    return sortedData;
  };

  const entityOptions = () => {
    let entityData = [];

    entitySubTypes.forEach(element => {
      entityData.push({
        ...element,
        label: element.Name,
        value: element.EntityId
      });
    });

    let sortedData = entityData.sort(compareValues('label'));
    sortedData.splice(0, 0, {
      label: <FormattedMessage id="wqsp.filters.allEntities" defaultMessage="All Entities" />,
      value: 0
    });
    return sortedData;
  };

  const testPurposeOptions = () => {
    let purposeData = [];

    let data = qualityGoals.filterData.TestPurposes;
    data.forEach(element => {
      purposeData.push({
        ...element,
        label: element.Name,
        value: element.TestPurposeId
      });
    });

    let sortedData = purposeData.sort(compareValues('label'));
    sortedData.splice(0, 0, {
      label: <FormattedMessage id="qualityGoals.allTestPurposes" defaultMessage="All Goal Purposes" />,
      value: 0
    });
    return sortedData;
  };

  const onPageChangeHandler = currentPage => {
    setCurrentPage(currentPage);
  };

  const onSortOrder = () => {
    setAsendingOrder(!asendingOrder);
  };

  const onSiteChange = e => {
    setFilterSiteId(e.value);
    filteredResults(SITE, e.value);
    setCurrentPage(1);
  };

  const onEntityTypeChange = e => {
    setFilterEntityTypeId(e.value);
    filteredResults(ENTITY_TYPE, e.value);
    setEntitySubTypes(generalData.entities.filter(item => item.EntityTypeId === e.value));
    setCurrentPage(1);
  };

  const onEntityChange = e => {
    setFilterEntityId(e.value);
    filteredResults(ENTITY, e.value);
    setCurrentPage(1);
  };

  const onTestPurposeChange = e => {
    setFilterTestPurposeId(e.value);
    filteredResults(TEST_PURPOSE, e.value);
    setCurrentPage(1);
  };

  const filteredResults = (filterType, value) => {
    let filteredList = qualityGoals.qualityGoals;

    let apifilterObj = {
      filterSiteId: null,
      filterEntityId: null,
      filterEntityTypeId: null,
      filterTestPurposeId: null
    };

    if (filterType === SITE) {
      if (value !== 0) {
        apifilterObj.filterSiteId = value;
        filteredList = filteredList.filter(function(item) {
          return item.SiteId === value;
        });
      }
    } else {
      if (filterSiteId !== 0) {
        apifilterObj.filterSiteId = filterSiteId;
        filteredList = filteredList.filter(function(item) {
          return item.SiteId === filterSiteId;
        });
      }
    }

    if (filterType === ENTITY_TYPE) {
      if (value !== 0) {
        apifilterObj.filterEntityTypeId = value;
        filteredList = filteredList.filter(function(item) {
          return item.EntityTypeId === value;
        });
      }
    } else {
      if (filterEntityTypeId !== 0) {
        apifilterObj.filterEntityTypeId = filterEntityTypeId;
        filteredList = filteredList.filter(function(item) {
          return item.EntityTypeId === filterEntityTypeId;
        });
      }
    }

    if (filterType === ENTITY) {
      if (value !== 0) {
        apifilterObj.filterEntityId = value;
        filteredList = filteredList.filter(function(item) {
          return item.EntityId === value;
        });
      }
    } else {
      if (filterEntityId !== 0) {
        apifilterObj.filterEntityId = filterEntityId;
        filteredList = filteredList.filter(function(item) {
          return item.EntityId === filterEntityId;
        });
      }
    }

    if (filterType === TEST_PURPOSE) {
      if (value !== 0) {
        apifilterObj.filterTestPurposeId = value;
        filteredList = filteredList.filter(function(item) {
          return item.GoalPurposeId === value;
        });
      }
    } else {
      if (filterTestPurposeId !== 0) {
        apifilterObj.filterTestPurposeId = filterTestPurposeId;
        filteredList = filteredList.filter(function(item) {
          return item.GoalPurposeId === filterTestPurposeId;
        });
      }
    }

    if (qualityGoals.qualityGoalsListCount > qualityGoals.qualityGoals.length) {
      dispatch(setPageFilter(apifilterObj));
    } else {
      dispatch(setFilteredDataThunk({ filteredResults: { filteredResults: filteredList } }));
    }
  };

  let qualityGoalsObj = (qualityGoals && Object.values(qualityGoals.filteredResults)) || [];

  if (asendingOrder) {
    qualityGoalsObj = qualityGoalsObj.sort(compareValues('TestDate'));
  } else {
    qualityGoalsObj = qualityGoalsObj.sort(compareValues('TestDate', 'desc'));
  }

  const onAddNewClick = () => {
    if (segmentName && entityId) {
      history.push(`/site/${siteId}/${segmentName}/${selectedTab}/entities/entity/${entityId}/quality-goals/quality-goals-report`);
    } else if (segmentName) {
      history.push(`/site/${siteId}/${segmentName}/${selectedTab}/quality-goals/quality-goals-report`);
    } else {
      history.push(`/quality-goals/quality-goals-report`);
    }
  };

  const onChangeQualityGoalsClick = (testGoalReportId, tblSiteId) => {
    if (entityId) {
      history.push(
        `/site/${siteId}/${segmentName}/${selectedTab}/entities/entity/${entityId}/quality-goals/quality-goals-report/${testGoalReportId}`
      );
    } else {
      history.push(`/site/${tblSiteId}/define/4/quality-goals/quality-goals-report/${testGoalReportId}`);
    }
  };

  const onQualityGoalsRemoveClick = qualityGoalReportId => {
    setActive(true);
    setQualityGoalReportId(qualityGoalReportId);
  };

  const handleClose = () => {
    setActive(false);
    setQualityGoalReportId(0);
  };

  const handleConfirm = () => {
    deleteQualityGoalsReport();
    handleClose();
  };

  const deleteQualityGoalsReport = () => {
    let saveData = {};
    saveData.PerformDelete = true;
    saveData.QualityGoalReportId = qualityGoalReportId;
    saveData.UpdatedBy = Cookies.get(`userid-${envName}`) || 0;
    dispatch(saveQualityGoalsThunk(saveData, 'WQSP_QUALITYGOALSREPORT_DELETE'));
  };

  const dialogTitle = intl.formatMessage({
    id: 'qualityGoals.confirmDelete',
    defaultMessage: 'Are you sure you want to delete this quality goals report?'
  });

  const isUpdateAllowed = IsWidgetAccessible(userProfileWidgets, 'WQSP_QUALITYGOALSREPORT_EDIT');
  const isDeleteAllowed = IsWidgetAccessible(userProfileWidgets, 'WQSP_QUALITYGOALSREPORT_DELETE');

  const breadcrumb = [
    {
      orderNo: 1,
      name: <FormattedMessage id="siteControlsTabs.entityListing" defaultMessage="List of Entities" />,
      url: `/site/${siteId}/${segmentName}/${selectedTab}/entities`,
      showlink: true,
      showCrumb: true
    },
    {
      orderNo: 2,
      name: <FormattedMessage id="qualityGoals.qualityGoals" defaultMessage="Quality Goals" />,
      url: ``,
      showlink: false,
      showCrumb: true
    }
  ];

  return (
    <div className={s.testResultList}>
      <SiteDashboardControlsContentTemplate
        selectedPage={selectedTab}
        siteId={siteId}
        segmentName={segmentName}
        userProfileWidgets={userProfileWidgets}
      >
        {segmentName ? (
          entityId && <Breadcrumb data={breadcrumb} segmentName={segmentName} />
        ) : (
          <div>
            <h1 className={s.tabHeader}>{<FormattedMessage id="qualityGoals.qualityGoals" defaultMessage="Quality Goals" />}</h1>
          </div>
        )}
        <ConfirmDialog title={dialogTitle} onConfirm={handleConfirm} onClose={handleClose} showDialog={active} />
        <div className={s.contentWrapper}>
          {qualityGoals.isLoading && <LoadingSpinner />}
          {qualityGoals.showBanner && (
            <Banner
              failureText={messageText}
              showBanner={qualityGoals.showBanner}
              status={qualityGoals.isOpSuccessful}
              successText={messageText}
            />
          )}
          <Row>
            <Col sm={12} lg={12}>
              <Button
                className={s.addbutton}
                style={WidgetVisibility(userProfileWidgets, 'WQSP_QUALITYGOALSREPORT_ADDNEW')}
                onClick={onAddNewClick}
                disabled={disableControls}
                data-unittest="addInspectionPurposeButton"
              >
                + <FormattedMessage id="common.addNew" defaultMessage="ADD NEW" />
              </Button>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <span className={s.textHeading}>
                {' '}
                <FormattedMessage id="common.filterBy" defaultMessage="Filter By" />
              </span>
            </Col>
          </Row>
          <Row className="pb-2">
            {!siteId && (
              <Col sm={6} lg={2}>
                <Dropdown
                  id="drp"
                  dataArray={siteOptions()}
                  controlData={{
                    placeholderText: <FormattedMessage id="wqsp.common.siteName" defaultMessage="Site Name" />,
                    customClassName: ''
                  }}
                  onDropdownChange={e => onSiteChange(e)}
                  selectedOption={siteOptions().filter(option => option.value === filterSiteId)}
                  disabled={disableControls}
                />
              </Col>
            )}
            {!entityId && (
              <Col sm={6} lg={2}>
                <Dropdown
                  id="drpEntityType"
                  dataArray={entityTypeOptions()}
                  controlData={{
                    placeholderText: <FormattedMessage id="wqsp.common.entityType" defaultMessage="Entity Type" />,
                    customClassName: ''
                  }}
                  onDropdownChange={e => onEntityTypeChange(e)}
                  selectedOption={entityTypeOptions().filter(option => option.value === filterEntityTypeId)}
                  disabled={disableControls}
                />
              </Col>
            )}
            {!entityId && (
              <Col sm={6} lg={2}>
                <Dropdown
                  id="drpEntity"
                  dataArray={entityOptions()}
                  controlData={{
                    placeholderText: <FormattedMessage id="wqsp.common.entity" defaultMessage="Entity" />,
                    customClassName: ''
                  }}
                  onDropdownChange={e => onEntityChange(e)}
                  selectedOption={entityOptions().filter(option => option.value === filterEntityId)}
                  disabled={disableControls}
                />
              </Col>
            )}
            <Col sm={6} lg={2}>
              <Dropdown
                id="drpComponentTypeId"
                dataArray={testPurposeOptions()}
                controlData={{
                  placeholderText: <FormattedMessage id="qualityGoals.goalPurpose" defaultMessage="Goal Purpose" />,
                  customClassName: ''
                }}
                onDropdownChange={e => onTestPurposeChange(e)}
                selectedOption={testPurposeOptions().filter(option => option.value === filterTestPurposeId)}
                disabled={disableControls}
              />
            </Col>
          </Row>
          <div className="">
            <Pagination
              data={qualityGoalsObj}
              pageSize={DEFAULT_PAGE_SIZE}
              onPageChange={onPageChangeHandler}
              startingPage={qualityGoals.currentPage}
            >
              <QualityGoalsReportListTable
                onSortOrder={onSortOrder}
                asendingOrder={asendingOrder}
                ChangeQualityGoalsReport={onChangeQualityGoalsClick}
                UpdateAllowed={isUpdateAllowed}
                currentTimezone={currentTimezone}
                deleteAllowed={isDeleteAllowed}
                removeQualityGoals={onQualityGoalsRemoveClick}
              />
            </Pagination>
          </div>
        </div>
      </SiteDashboardControlsContentTemplate>
    </div>
  );
};

export default injectIntl(QualityGoalsReportList);
